var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"27a81a7b8331e56b5a5d357c222d2875abf4ed30"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kaiklive@kaik"]={id:"27a81a7b8331e56b5a5d357c222d2875abf4ed30"};
      